module.exports = __webpack_public_path__ + "img/8.88e72b76.svg";